import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {IconContentItem} from 'components/molecules';
import './IconContentList.scss'

export const IconContentList = ({ 
  className, 
  items = [], 
  columns, 
  rowGap, 
  colGap, 
  ItemComponent = IconContentItem,
  ...rest 
}) => {
  const gridStyle = {
    '--fl-columns': columns,
    '--fl-row-gap': rowGap,
    '--fl-col-gap': colGap,
  };

  return (
    <ul className={classnames('feature-list', className)} style={gridStyle} role="list" {...rest}>
      {items && items.map((item, index) => {
        const key = item?.id != null ? item?.id : `${item?.title || 'item'}-${index}`;

        return (
          <li className="feature-list__item" key={key}>
            <ItemComponent {...item} />
          </li>
        );
      })}
    </ul>
  );
};

IconContentList.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.number, // number of grid columns
  gap: PropTypes.string,     // grid gap string
  items: PropTypes.arrayOf(PropTypes.object),
  ItemComponent: PropTypes.elementType, // Component to render for each item
  itemProps: PropTypes.object, // Additional props to pass to each ItemComponent
};

IconContentList.defaultProps = {
  className: '',
  columns: 2,
  rowGap: '2rem',
  colGap: '4rem',
  items: [],
  ItemComponent: IconContentItem,
  itemProps: {},
};

export default IconContentList;